import { app } from '../../../../../app';
import { Controller } from './remove-role.controller';

app.component('companyManageApplicationRolesRemove', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-role.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/remove/remove-role.component.js